var map = {
	"./assets/thewest-digital-hero-variation-eofy-mobile.jpg": 880,
	"./assets/thewest-digital-hero-variation-footy-lives-here-mobile.jpg": 882,
	"./assets/thewest-digital-hero-variation-summer-of-cricket-mobile.jpg": 883
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2998;